'use client';

import React from 'react';
import { passwordStrength } from '@/lib/validators';

/**
 * Indicador visual compacto de forca da senha + hint 1 linha.
 *
 * Substitui o checklist verboso (4 itens) do form de cadastro tradicional
 * por uma barra de 4 niveis colorida + texto descritivo. Mantem o requisito
 * minimo do backend (8+ chars com letras e numeros).
 */
interface PasswordStrengthProps {
  password: string;
}

export function PasswordStrength({ password }: PasswordStrengthProps) {
  const { score, label } = passwordStrength(password);
  const filled = password.length === 0 ? 0 : Math.max(1, score);

  return (
    <div className="password-strength" aria-live="polite">
      <div
        className="password-strength__bars"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={4}
        aria-valuenow={score}
      >
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={`password-strength__bar password-strength__bar--${
              filled > i ? `lvl-${score}` : 'idle'
            }`}
          />
        ))}
      </div>
      <span
        className={`password-strength__label password-strength__label--lvl-${score}`}
      >
        {password.length === 0
          ? '8+ caracteres com letras e números'
          : label}
      </span>
    </div>
  );
}
